/**
 * Global variable for booking. This uses to expose public methods.
 *
 * @since 1.15.79
 */
export const HookApi = () => {
	return window.wc_bookings.hooks;
};

export const BookingDisabledClass = 'disabled';

/**
 * Set the button disabled state.
 *
 * The native `disabled` attribute is deliberately not set: browsers dispatch no
 * click on a natively disabled button, so the booking form's click handler could
 * never tell the customer what is missing, and keyboard users could not reach the
 * button. The handler blocks submission while the class is present instead.
 *
 * @param {Object}  button   jQuery button.
 * @param {boolean} disabled Whether to disable the button.
 * @return {void}
 */
export const SetButtonDisabled = ( button, disabled ) => {
	if ( disabled ) {
		button.addClass( BookingDisabledClass ).attr( 'aria-disabled', 'true' );
	} else {
		button
			.removeClass( BookingDisabledClass )
			.removeAttr( 'aria-disabled' )
			.removeAttr( 'disabled' );
	}
};
